module.exports = __webpack_public_path__ + "img/help-support.b1dc1396.svg";